var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"hr"}),_c('div',{staticClass:"span"},[_vm._v(_vm._s(_vm.$t('common.bottomBarText')))]),_c('div',{staticClass:"hr"})])
}
var staticRenderFns = []

export { render, staticRenderFns }